
import type { ComponentProps } from 'react';
import { RouterLinkAs } from '@/lib/router-link';
import { PersonRow } from '@leanin/ui';
import { memberPath } from '../lib/routes';

type Props = Omit<ComponentProps<typeof PersonRow>, 'href' | 'linkAs'> & {
  // Pass `null` (or omit) to render a non-clickable row — e.g. for tombstoned
  // authors whose member identity is no longer resolvable. The override lets
  // the suggested-members rail thread `?from-rec=...&iset=...` onto the link
  // without bypassing the wrapper.
  userId?: string | null;
  href?: string;
};

export function MemberRow({ userId, href, ...rest }: Props) {
  const resolvedHref = href ?? (userId ? memberPath(userId) : undefined);
  if (resolvedHref) {
    return <PersonRow href={resolvedHref} linkAs={RouterLinkAs} {...rest} />;
  }
  return <PersonRow {...rest} />;
}
